<template>
  <base-dialog @cancel="cancelDialog" width="50%">
    <div slot="header">{{ params.title }}</div>
    <div slot="body">
      <a-form :form="form.fc">
        <a-form-item :label="$t('system.text_307')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.topic" :placeholder="$t('system.text_232', [$t('system.text_307')])" />
        </a-form-item>
        <a-form-item :label="$t('system.text_308')" v-bind="formItemLayout">
          <a-textarea v-decorator="decorators.message" :placeholder="$t('system.text_232', [$t('system.text_308')])" />
        </a-form-item>
        <a-form-item :label="$t('system.notify.subscriber.receivers')" v-bind="formItemLayout">
          <user-select v-decorator="decorators.contacts" />
        </a-form-item>
        <a-form-item :label="$t('system.text_315')" v-bind="formItemLayout">
          <a-select v-decorator="decorators.priority" :placeholder="$t('system.text_232', [$t('system.text_315')])">
            <a-select-option v-for="(key, value) in priorities" :key="key" :value="value">
              {{ $t(`notificationPriority.${value}`) }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('system.notify.topic.type')" v-bind="formItemLayout">
          <a-select v-decorator="decorators.topic_type" :placeholder="$t('system.text_232', [$t('system.notify.topic.type')])" @change="handleTopicTypeChange">
            <a-select-option v-for="(key, value) in sendTypes" :key="key" :value="value">
              {{ $t(`system.notify.topic.type.${value}`) }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="canExpire" :label="$t('system.text_593')" v-bind="formItemLayout">
          <a-date-picker
            v-decorator="decorators.expired_at"
            show-time
            format="YYYY-MM-DD HH:mm:ss" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" :loading="loading" @click="handleConfirm">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import UserSelect from '@/components/UserSelect'
import { NOTIFICATION_PRIORITY, NOTIFICATION_SEND_TYPE } from '@/constants/notification'

export default {
  name: 'MessageSendDialog',
  components: {
    UserSelect,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      priorities: NOTIFICATION_PRIORITY,
      sendTypes: NOTIFICATION_SEND_TYPE,
      form: {
        fc: this.$form.createForm(this),
      },
      topicType: '',
      decorators: {
        topic: [
          'topic',
          {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('system.text_312') },
            ],
          },
        ],
        message: [
          'message',
          {
            rules: [
              { required: this.topicType === NOTIFICATION_SEND_TYPE.announcement, message: this.$t('system.text_594') },
            ],
          },
        ],
        contacts: [
          'contacts',
          {
            validateFirst: true,
          },
        ],
        priority: [
          'priority',
          {
            initialValue: 'normal',
            validateFirst: true,
          },
        ],
        topic_type: [
          'topic_type',
          {
            initialValue: 'notice',
            validateFirst: true,
          },
        ],
        expired_at: [
          'expired_at',
          {
            validateFirst: true,
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 6,
        },
      },
    }
  },
  computed: {
    canExpire () {
      return this.topicType === NOTIFICATION_SEND_TYPE.announcement
    },
  },
  methods: {
    validateForm () {
      return new Promise((resolve, reject) => {
        this.form.fc.validateFields((err, values) => {
          if (!err) {
            resolve(values)
          } else {
            reject(err)
          }
        })
      })
    },
    handleTopicTypeChange (value) {
      this.topicType = value
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.validateForm()
        const data = {
          ...values,
        }
        this.loading = true
        await this.params.onSend?.(data)
        this.$message.success(this.$t('common.success'))
        this.cancelDialog()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
